"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainScreen = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const analytics_1 = require("@completeanatomy/analytics");
const breadcrumb_trail_1 = require("@completeanatomy/breadcrumb-trail");
const bridge_1 = require("@completeanatomy/bridge");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const i18n_1 = require("@completeanatomy/i18n");
const infobox_1 = require("@completeanatomy/infobox");
const model_systems_1 = require("@completeanatomy/model-systems");
const models_1 = require("@completeanatomy/models");
const tools_1 = require("@completeanatomy/tools");
const ui_1 = require("@completeanatomy/ui");
const mediaQuery_1 = require("../../cssMixins/mediaQuery");
const hooks_1 = require("../../hooks");
const useStateReducer_1 = require("../../hooks/useStateReducer");
const useToolsState_1 = require("../../hooks/useToolsState");
const AccountInfoSidePanel_1 = __importDefault(require("../../molecules/AccountInfoSidePanel"));
const organisms_1 = require("../../organisms");
const DescriptionPanel_1 = __importDefault(require("../../organisms/DescriptionPanel"));
const SearchPanel_1 = __importDefault(require("../../organisms/SearchPanel"));
const MainScreenStateProvider_1 = require("../../providers/MainScreenStateProvider");
const focus_trap_react_1 = require("focus-trap-react");
const hotkeys_js_1 = __importDefault(require("hotkeys-js"));
const react_1 = require("react");
const styled_components_1 = __importStar(require("styled-components"));
// eslint-disable-next-line max-lines-per-function
function MainScreen({ webSdkId }) {
    const analitycs = (0, analytics_1.useAnalytics)();
    const selectedPart = (0, models_1.useSelectedPart)();
    const systems = (0, model_systems_1.useSystemState)();
    const [{ currentTab }, dispatch] = (0, MainScreenStateProvider_1.useMainScreenStateContext)();
    const isLower = (0, ui_1.useScreenBreakpoint)(mediaQuery_1.size.tablet);
    const isTouchDevice = (0, ui_1.useIsTouchDevice)();
    const isLandscape = (0, ui_1.useOrientation)();
    const screenInfo = (0, hooks_1.useScreenInfo)();
    const state = (0, useToolsState_1.useToolsState)();
    const bridge = (0, bridge_1.useBridge)();
    const theme = (0, styled_components_1.useTheme)();
    const isLoading = (0, models_1.useIsModelLoading)();
    const progress = (0, models_1.useDownloadingProgress)();
    const labelsRef = (0, react_1.useRef)(null);
    const searchRef = (0, react_1.useRef)(null);
    const descriptionRef = (0, react_1.useRef)(null);
    const ignoreRef = (0, react_1.useRef)(null);
    const closeDescriptionButtonRef = (0, react_1.useRef)(null);
    const containerRef = (0, react_1.useRef)(null);
    const [progressAnimation, setProgressAnimation] = (0, react_1.useState)(0);
    const [isLabelsOpen, setIsLabelsOpen] = (0, react_1.useState)(true);
    const [isOpen, setIsOpen] = (0, react_1.useState)(true);
    const [isExpandSystems, setIsExpandSystems] = (0, react_1.useState)(false);
    const [isSearchOpen, setIsSearchOpen] = (0, react_1.useState)(false);
    const [isDescriptionOpen, setIsDescriptionOpen] = (0, react_1.useState)(false);
    const [isOverlayOpened, setIsOverlayOpened] = (0, react_1.useState)(false);
    const [isOverlayInfoboxOpened, setIsOverlayInfoboxOpened] = (0, react_1.useState)(false);
    const [resetButtonPressed, setResetButtonPressed] = (0, react_1.useState)(false);
    const [isModelFullLoad, setIsModelFullLoad] = (0, react_1.useState)(false);
    const [isHaveLabelsOrStickies, setIsHaveLabelsOrStickies] = (0, react_1.useState)(false);
    const [isAccountMenuSidePanelOpen, setIsAccountMenuSidePanelOpen] = (0, react_1.useState)(false);
    const [selectedItem, setSelectedItem] = (0, react_1.useState)(null);
    const onClickSystemPanel = () => {
        analitycs.log(`collapse_systems_pressed`, {
            name: 'system menu' + isOpen ? 'hide' : 'show',
        });
        setIsOpen(!isOpen);
    };
    (0, react_1.useEffect)(() => {
        setTimeout(() => {
            document.body.focus();
        }, 0);
    }, []);
    (0, react_1.useEffect)(() => {
        (0, hotkeys_js_1.default)('option+d, alt+d', event => {
            event.preventDefault();
            screenInfo.information && setIsDescriptionOpen(true);
            event.stopPropagation();
        });
        (0, hotkeys_js_1.default)('command+alt+d, ctrl+alt+d', event => {
            event.preventDefault();
            screenInfo.information && setIsDescriptionOpen(false);
            event.stopPropagation();
        });
        (0, hotkeys_js_1.default)('option+s, alt+s', event => {
            event.preventDefault();
            setIsSearchOpen(true);
            event.stopPropagation();
        });
        (0, hotkeys_js_1.default)('command+alt+s, ctrl+alt+s', event => {
            event.preventDefault();
            setIsSearchOpen(false);
            event.stopPropagation();
        });
        (0, hotkeys_js_1.default)('option+r, alt+r', event => {
            event.preventDefault();
            bridge === null || bridge === void 0 ? void 0 : bridge.historyResetScreenPressed();
            setResetButtonPressed(true);
            event.stopPropagation();
        });
        (0, hotkeys_js_1.default)('alt+l', event => {
            event.preventDefault();
            setIsLabelsOpen(true);
            event.stopPropagation();
        });
        (0, hotkeys_js_1.default)('command+alt+l, ctrl+alt+l', event => {
            event.preventDefault();
            setIsLabelsOpen(false);
            event.stopPropagation();
        });
        (0, hotkeys_js_1.default)('option+t, alt+t', event => {
            event.preventDefault();
            dispatch((0, useStateReducer_1.selectTab)(useStateReducer_1.TabType.None));
            event.stopPropagation();
        });
        (0, hotkeys_js_1.default)('command+alt+t, ctrl+alt+t', event => {
            event.preventDefault();
            dispatch((0, useStateReducer_1.selectTab)(useStateReducer_1.TabType.Hide));
            event.stopPropagation();
        });
        return () => {
            hotkeys_js_1.default.unbind('option+d, alt+d');
            hotkeys_js_1.default.unbind('command+alt+d, ctrl+alt+d');
            hotkeys_js_1.default.unbind('option+s, alt+s');
            hotkeys_js_1.default.unbind('command+alt+s, ctrl+alt+s');
            hotkeys_js_1.default.unbind('option+r, alt+r');
            hotkeys_js_1.default.unbind('option+l, alt+l');
            hotkeys_js_1.default.unbind('command+alt+l, ctrl+alt+l');
            hotkeys_js_1.default.unbind('option+t, alt+t');
            hotkeys_js_1.default.unbind('command+alt+t, ctrl+alt+t');
        };
    }, [bridge, dispatch, screenInfo]);
    // for first load of the model
    (0, react_1.useEffect)(() => {
        if (isLoading && !isModelFullLoad) {
            return () => {
                setIsModelFullLoad(true);
            };
        }
    }, [isLoading, isModelFullLoad]);
    //progress animation for user experience, it will show the progress of the model loading with dynamic animation
    (0, react_1.useEffect)(() => {
        if (!isLoading || isOverlayInfoboxOpened || isModelFullLoad) {
            setProgressAnimation(0);
            return;
        }
        // change progressAnimation only if progress is greater to show speed of progress
        if (progress > progressAnimation) {
            setProgressAnimation(+progress.toFixed(0));
        }
        const interval = setInterval(() => {
            setProgressAnimation(prev => {
                if (prev >= 100) {
                    clearInterval(interval);
                    return prev;
                }
                return prev + 1;
            });
        }, 1000);
        return () => {
            window.clearInterval(interval);
        };
    }, [
        progress,
        isLoading,
        isOverlayInfoboxOpened,
        progressAnimation,
        isModelFullLoad,
    ]);
    const isHided = currentTab === useStateReducer_1.TabType.Hide;
    (0, react_1.useEffect)(() => {
        var _a, _b, _c, _d;
        setIsHaveLabelsOrStickies(!!((_b = (_a = state === null || state === void 0 ? void 0 : state.labelsState) === null || _a === void 0 ? void 0 : _a.labels) === null || _b === void 0 ? void 0 : _b.length) ||
            !!((_d = (_c = state === null || state === void 0 ? void 0 : state.stickiesState) === null || _c === void 0 ? void 0 : _c.stickies) === null || _d === void 0 ? void 0 : _d.length));
    }, [state]);
    (0, react_1.useEffect)(() => {
        if (isHaveLabelsOrStickies) {
            setIsLabelsOpen(true);
        }
        else {
            setIsLabelsOpen(false);
        }
    }, [isHaveLabelsOrStickies]);
    const onClickSpots = (id) => {
        setSelectedItem({ identifier: id });
        setIsOverlayOpened(true);
    };
    const onOverlayClosed = () => {
        setIsOverlayOpened(false);
        setSelectedItem(null);
    };
    const onClickLabelsButton = (0, react_1.useCallback)(() => {
        setIsLabelsOpen(!isLabelsOpen);
        isLower && setIsDescriptionOpen(false);
        isLower && setIsSearchOpen(false);
    }, [isLower, isLabelsOpen]);
    const onCloseLabels = (0, react_1.useCallback)(() => {
        // add delay for the animation
        window.setTimeout(() => {
            setIsLabelsOpen(false);
            isLower && setIsDescriptionOpen(false);
            isLower && setIsSearchOpen(false);
        }, 100);
    }, [isLower]);
    const onClickSearch = () => {
        analitycs.log('search_opened');
        setIsSearchOpen(!isSearchOpen);
        setIsDescriptionOpen(false);
    };
    const onClickReset = (0, react_1.useCallback)(() => {
        bridge === null || bridge === void 0 ? void 0 : bridge.historyResetScreenPressed();
        setResetButtonPressed(true);
        analitycs.log('reset_screen_pressed');
        isHaveLabelsOrStickies && setIsLabelsOpen(true);
    }, [analitycs, bridge, isHaveLabelsOrStickies]);
    const onCloseSidePanel = () => setIsAccountMenuSidePanelOpen(false);
    const onClickLogo = () => setIsAccountMenuSidePanelOpen(true);
    const onClickDescription = () => {
        setIsDescriptionOpen(!isDescriptionOpen);
        setIsSearchOpen(false);
    };
    const onCloseDescription = () => {
        setIsSearchOpen(false);
        setIsDescriptionOpen(false);
    };
    const onSearchClose = () => {
        setIsSearchOpen(false);
    };
    (0, ui_1.useOutsideClick)(searchRef, onCloseDescription, [ignoreRef], {
        active: true,
        stopPropagation: false,
    });
    (0, ui_1.useOutsideClick)(descriptionRef, onCloseDescription, [ignoreRef], {
        active: true,
        stopPropagation: true,
    });
    (0, react_1.useEffect)(() => {
        if (isSearchOpen) {
            bridge === null || bridge === void 0 ? void 0 : bridge.didEnterSearch();
            return;
        }
        bridge === null || bridge === void 0 ? void 0 : bridge.didExitSearch();
    }, [bridge, isSearchOpen]);
    const isSearchOpenOnMobile = isSearchOpen && isLower;
    const isBreadcrumbTrailAvailable = !isSearchOpenOnMobile && !isDescriptionOpen && !isSearchOpen;
    return ((0, jsx_runtime_1.jsx)(focus_trap_react_1.FocusTrap, { focusTrapOptions: { clickOutsideDeactivates: true, initialFocus: false }, active: !isOverlayOpened, children: (0, jsx_runtime_1.jsxs)(MainScreenContainer, { ref: containerRef, children: [!isSearchOpenOnMobile && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(Toolbars, { ref: ignoreRef, "$isHided": isHided, "$isMobile": isLower, "$isLandscape": isLandscape, "$isSearchOpen": isSearchOpen, children: [!isHided && ((0, jsx_runtime_1.jsx)(organisms_1.MainToolbar, { isSearchOpen: isSearchOpen, onClickDescription: onClickDescription, onClickSearch: onClickSearch, onClickLogo: onClickLogo, closeDescriptionButtonRef: closeDescriptionButtonRef, isDescriptionOpen: isDescriptionOpen })), (0, jsx_runtime_1.jsx)(organisms_1.SecondaryToolbar, { isSearchOpen: isSearchOpen, isLabelsOpen: isLabelsOpen, isDescriptionOpen: isDescriptionOpen, onClickDescription: onClickDescription, onClickSearch: onClickSearch, onClickReset: onClickReset, onClickLabelsButton: onClickLabelsButton, closeDescriptionButtonRef: closeDescriptionButtonRef, setResetButtonPressed: setResetButtonPressed })] }), isTouchDevice && ((0, jsx_runtime_1.jsx)(AccountInfoSidePanel_1.default, { isOpen: isAccountMenuSidePanelOpen, onCloseSidePanel: onCloseSidePanel }))] })), !isHided && ((0, jsx_runtime_1.jsx)(SearchPanel_1.default, { isOpen: isSearchOpen && !isOverlayOpened, onClose: onSearchClose, onClickSpots: onClickSpots })), !isSearchOpen && screenInfo.information && isDescriptionOpen && ((0, jsx_runtime_1.jsx)(DescriptionContainer, { ref: descriptionRef, children: (0, jsx_runtime_1.jsx)(DescriptionPanel_1.default, { closeDescriptionButtonRef: closeDescriptionButtonRef, onClose: onCloseDescription, descriptionText: screenInfo.information }) })), !isHided && !(isLabelsOpen && isLower) && systems.length > 0 && ((0, jsx_runtime_1.jsx)(SystemPanelContainer, { "$isMobile": isLower, children: (!isLower || !selectedPart.identifier) && ((0, jsx_runtime_1.jsx)(model_systems_1.SystemsPanel, { isOpen: isOpen, onClick: onClickSystemPanel, setIsExpandSystems: setIsExpandSystems, resetButtonPressed: resetButtonPressed, setResetButtonPressed: setResetButtonPressed })) })), !isHided && isBreadcrumbTrailAvailable && ((0, jsx_runtime_1.jsx)(BreadcrumbTrailStyled, { style: !isLower
                        ? {
                            width: isExpandSystems
                                ? 'calc(100vw - 298px)'
                                : 'calc(100vw - 175px)',
                        }
                        : { width: '100%' }, "$isMobile": isLower })), !isHided && !(isLabelsOpen && isLower) && selectedPart.identifier && ((0, jsx_runtime_1.jsx)(Infobox, { "$isMobile": isLower, "$isOverlayInfoboxOpened": isOverlayInfoboxOpened, children: (0, jsx_runtime_1.jsx)(infobox_1.InfoboxPanel, { setIsOverlayOpened: setIsOverlayInfoboxOpened, isOverlayOpened: isOverlayInfoboxOpened, selectedOverlayItem: selectedItem || undefined, isSearchPanel: isSearchOpen, isVisible: !isSearchOpen, onOverlayClosed: onOverlayClosed }) })), isLabelsOpen && !isHided && isLower && ((0, jsx_runtime_1.jsx)(tools_1.LabelsAnnotationsPanel, { buttonRef: labelsRef, isOpen: isLabelsOpen, onClose: onCloseLabels })), !isOverlayInfoboxOpened && !isLower && ((0, jsx_runtime_1.jsx)(tools_1.Tools, { hideLabelState: !isLabelsOpen, selectedToolType: bridge_schema_1.ToolType.None, guidesPanelDisable: true, isStickyEditable: false })), (0, jsx_runtime_1.jsxs)(CanvasContainer, { id: "canvas-container", tabIndex: -1, children: [(0, jsx_runtime_1.jsx)("div", { id: webSdkId }), isLoading && !isOverlayInfoboxOpened && ((0, jsx_runtime_1.jsx)(ProgressBarContainer, { children: (0, jsx_runtime_1.jsx)(ui_1.ProgressBar, { value: progress, backgroundColor: theme.grasshopper.modelBackground }) })), isLoading && !isOverlayInfoboxOpened && ((0, jsx_runtime_1.jsxs)(ProgressIndicatorContainer, { children: [!isModelFullLoad && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(ProgressText, { children: (0, i18n_1.Localized)(i18n_1.Strings.modelDownloading.loadingModel) }), (0, jsx_runtime_1.jsxs)(ProgressValue, { children: [progressAnimation, "%"] })] })), (0, jsx_runtime_1.jsx)(StyledProgressIndicator, { color: theme.grasshopper.loadingColor })] }))] })] }) }));
}
exports.MainScreen = MainScreen;
const ProgressIndicatorContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  z-index: 12;
`;
const ProgressText = styled_components_1.default.div `
  font-weight: 400;
  font-size: 32px;

  line-height: 48px;
  letter-spacing: 0;
  text-align: center;
  font-family: 'Elsevier Sans', sans-serif;

  color: ${({ theme }) => theme.grasshopper.text.white};
`;
const ProgressValue = styled_components_1.default.div `
  font-weight: 400;
  font-size: 48px;

  line-height: 48px;
  letter-spacing: 0;
  text-align: center;
  font-variant-numeric: lining-nums;
  font-family: 'Elsevier Sans', sans-serif;

  margin-top: 32px;

  color: ${({ theme }) => theme.grasshopper.text.white};
`;
const StyledProgressIndicator = (0, styled_components_1.default)(ui_1.ProgressIndicator) `
  display: flex;
  justify-content: center;
  margin-top: 42px;

  margin-top: 42px;
`;
const ProgressBarContainer = styled_components_1.default.div `
  position: absolute;
  width: calc(100vw - 16px);
  left: 8px;
  top: 0px;

  z-index: 12;
`;
const CanvasContainer = styled_components_1.default.div `
  width: 100%;
  height: 100dvh;
  top: 0;
  left: 0;
`;
const SystemPanelContainer = styled_components_1.default.div `
  position: absolute;
  z-index: 9;

  right: 0px;
  bottom: ${({ $isMobile }) => $isMobile ? 'env(safe-area-inset-bottom)' : 'initial'};
  top: ${({ $isMobile }) => ($isMobile ? 'initial' : '0')};

  padding: ${({ $isMobile }) => ($isMobile ? '0' : '8px')};

  min-width: ${({ $isMobile }) => ($isMobile ? '100%' : '168px')};
  max-width: ${({ $isMobile }) => ($isMobile ? '100%' : '290px')};
  height: ${({ $isMobile }) => ($isMobile ? 'auto' : '100%')};

  * {
    -webkit-tap-highlight-color: transparent;
  }

  ${ui_1.deviceMainScreen.tablet((0, styled_components_1.css) `
    right: 0px;
  `)};
`;
const DescriptionContainer = styled_components_1.default.div `
  margin: 0;
  padding: 0;
`;
const MainScreenContainer = styled_components_1.default.div `
  font-family: 'Elsevier Sans', sans-serif;
  position: relative;
  width: 100vw;
  height: 100dvh;
  overflow: hidden;
  background-color: ${({ theme }) => theme.grasshopper.modelBackground};
`;
const BreadcrumbTrailStyled = (0, styled_components_1.default)(breadcrumb_trail_1.BreadcrumbTrail) `
  z-index: 10;
  position: fixed;
  top: 64px;
`;
const Infobox = styled_components_1.default.div `
  z-index: ${({ $isOverlayInfoboxOpened, $isMobile }) => $isOverlayInfoboxOpened || $isMobile ? 13 : 11};
  position: absolute;
  top: ${({ $isMobile }) => ($isMobile ? '0' : '116px')};
  left: ${({ $isMobile }) => ($isMobile ? '0' : '8px')};
  bottom: ${({ $isMobile }) => $isMobile ? 'env(safe-area-inset-bottom)' : 'unset'};
  width: ${({ $isMobile }) => ($isMobile ? '100vw' : 'unset')};

  pointer-events: none;

  & > * {
    pointer-events: auto;
  }
`;
const Toolbars = styled_components_1.default.div `
  z-index: 12;
  pointer-events: none;
  position: absolute;
  top: 8px;
  left: ${({ $isHided, $isSearchOpen, $isMobile }) => $isHided || ($isSearchOpen && $isMobile) ? '0' : '8px'};
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
  width: calc(100vw - 8px);

  & > * {
    pointer-events: auto;
  }

  flex-direction: ${({ $isMobile, $isLandscape }) => $isMobile && !$isLandscape ? 'column' : 'row'};
`;
